import PropTypes from 'prop-types';
import React from 'react';
import { useHistory } from 'react-router';
import { ROUTE_CHANGE_PAYMENT_DETAILS_BEDROCK } from '../../../constants/Routes';
import Button, { BUTTON_KIND_WHITE } from '../../common/buttons/button/Button';
import { ACCOUNT_CHANGE_PAYMENT_DETAILS } from '../../../constants/Copy';
import { analyticsPush } from '../../../actions/applicationActions';
import { EVT_CLICKED_CHANGE_PAYMENT_DETAILS } from '../../../constants/EventTypes';
import { useDispatch, useSelector } from 'react-redux';
import { initiateTrackStructEvent } from '../../analytics/Snowplow';
import {
	EVT_ACCOUNT,
	EVT_ELEMENT_INTERACTION,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_PAYMENT_CHANGE,
	EVT_START,
} from '../../../constants/SnowplowEvents';
import { getCurrrentPlan } from '../../../helpers/state';

const AccountBedrockDetails = ({ paymentDetails }) => {
	const history = useHistory();
	const dispatch = useDispatch();
	const currentPlan = useSelector((state) => getCurrrentPlan(state));
	const currentPlanId = currentPlan?.planDescription.planId;
	const activeSubscription = useSelector((state) => state.subscription.details.data);

	const disabledChangePaymentDetails =
		!paymentDetails?.me.paymentDetails || !activeSubscription.allowsPaymentMethodChange;

	async function handleChangePaymentDetailsClick() {
		await initiateTrackStructEvent({
			category: EVT_ACCOUNT,
			action: EVT_PAYMENT_CHANGE,
			label: EVT_START,

			rtlElementContext: {
				elementInteraction: EVT_ELEMENT_INTERACTION,
				elementGroup: EVT_PAYMENT_CHANGE,
				elementType: EVT_ELEMENT_TYPE_BUTTON,
				elementName: EVT_PAYMENT_CHANGE,
				elementLabel: ACCOUNT_CHANGE_PAYMENT_DETAILS,
			},
			rtlFunnel: {
				funnelName: EVT_PAYMENT_CHANGE,
				funnelStepName: 'Start Payment Change',
				funnelStep: '01',
				funnelSubscriptionType: currentPlanId,
			},
		});
		dispatch(
			analyticsPush({ label: ACCOUNT_CHANGE_PAYMENT_DETAILS }, EVT_CLICKED_CHANGE_PAYMENT_DETAILS)
		);
		history.push(ROUTE_CHANGE_PAYMENT_DETAILS_BEDROCK);
	}

	return (
		<Button
			kind={BUTTON_KIND_WHITE}
			onClick={handleChangePaymentDetailsClick}
			disabled={disabledChangePaymentDetails}
		>
			{ACCOUNT_CHANGE_PAYMENT_DETAILS}
		</Button>
	);
};

AccountBedrockDetails.propTypes = {
	paymentDetails: PropTypes.object,
};

export default AccountBedrockDetails;
